import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GoBack, PrimaryButton } from "../components/Buttons";
import { useLoaderStore, useUserStore } from "../context";
import { useAlert, useApi } from "../hooks";
import constants from "../utils/constants";
import { resolveSystemTenantId } from "../utils/helpers";
import dateHelpers from "../utils/dateHelpers";

export default function Notification() {
    let { id, systemTenantId } = useParams();
    const navigate = useNavigate();
    const alert = useAlert();
    const { setShowLoader } = useLoaderStore();
    const { currentUser, activeSystemTenant } = useUserStore();
    const { fetch, post } = useApi();
    const { PROFILE, ACTIVITY, NOTIFICATIONS } = constants.SYS_TENANT_TABS;
    const [notification, setNotification] = useState();
    useEffect(()=>{
        getNotification();
    }, []);

    function getNotification(){
        setShowLoader(true);
        fetch(`admin/NotificationInfo/${id}/${systemTenantId}`)
        .then((res) => {
            setNotification(res);
        })
        .catch(() => {
            alert("Server error", "Could not retrieve product", "error");
        })
        .finally(() => setShowLoader(false));
    }

    return (
        <div>
            <GoBack display="Return to Notifications" navigateTo={`/systemTenants/${systemTenantId}?tab=${NOTIFICATIONS}`} />
            <div className="my-4 p-4 bg-gray-200 rounded-lg">
                <h3 className="font-bold text-xl mb-3">Notification</h3>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Id:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{notification?.id} </h6>
                    </div>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Tenant:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{notification?.tenantName} </h6>
                    </div>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Email:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{notification?.email} </h6>
                    </div>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Phone:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{notification?.MobilePhone} </h6>
                    </div>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Notification Method:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{notification?.notificationMethod} </h6>
                    </div>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Message:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{notification?.message} </h6>
                    </div>
                </div>
                <div className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
                    <div>
                        <h6 className="font-semibold my-3">Sent At:</h6>
                        <h6 className="block text-sm font-normal text-gray-700">{dateHelpers.localDateTime(notification?.sentAt, dateHelpers.YMDHMSA)} </h6>
                    </div>
                </div>
            </div>
        </div>
    );
}